import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    messagebar:false,
    apisuccess: {
        message:'',
        action:''
    },
    apierror: {
        message:'',
        action:''
    },  
    mainlogo: process.env.VUE_APP_API_PATH + 'storage/images/nblogo.jpg',
    paths: {
        basepath:process.env.VUE_APP_API_PATH,
        storagepath:process.env.VUE_APP_API_PATH + 'storage/',
        recipepath:process.env.VUE_APP_API_PATH + 'storage/' + 'rezepte/'
        
    }
    
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};